import { ClerkProvider } from '@clerk/clerk-react';

// Get the Clerk publishable key from Create React App environment variables
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  throw new Error('Missing Clerk Publishable Key');
}

export const clerkConfig = {
  publishableKey: clerkPubKey,
  appearance: {
    variables: {
      colorPrimary: '#FF385C',
    },
  },
};

export { ClerkProvider }; 
